module.exports = __webpack_public_path__ + "img/time-MT5.245ae172.png";